import {
    Icon,
    Level,
    LevelLeft,
    Loader,
    Title,
} from "components/ui";
import { useApi } from "hooks/api";
import { useQuery } from "react-query";
import FolderList from "./FolderList";
import MoodBoardList from "./MoodBoardList";
import { useState } from "react";
import { useFilter } from "hooks/filter";

export default function FolderMoodBoardPanel(props: {
    closePanel: () => void;
    showFolders: boolean;
    showMoodboards: boolean;
}) {
    const { getFolders } = useApi();
    const { searchState } = useFilter();
    const [isFolderSelected, setFolderSelected] = useState(props.showFolders);
    const [isMoodboardSelected, setMoodboardSelected] = useState(!props.showFolders && props.showMoodboards);

    const {
        isLoading: folderLoading,
        isError: folderIsError,
        error: folderError,
        data: folders,
    } = useQuery(
        ["getFolders", searchState.currentFolderId],
        () => getFolders(searchState.currentFolderId),
        {
            retry: 0,
        }
    );


    if (folderLoading) {
        return <Loader />;
    }
    if (folderIsError)
        console.error("Error fetching folders:", folderError);

    const bothTabsVisible = () => {
        return props.showFolders && props.showMoodboards;
    }
    const handleMoodboardVisible = () => {
        setMoodboardSelected(true);
        setFolderSelected(false);
    }
    const handleFolderVisible = () => {
        setFolderSelected(true);
        setMoodboardSelected(false);
    }
    return (
        <>
            <Level className="level-header">
                <LevelLeft
                    className="advanced-search-panel-back is-clickable"
                    onClick={props.closePanel}
                >
                    <Icon name="arrow-left" />
                    <Title className="title-white text-subheading" size={6}>Back</Title>
                </LevelLeft>
            </Level>
            <div className="advanced-search-main">
                <div className="advanced-search-panel scroll-bars is-active with-custom-padding">
                    <div className={"menu-item"}>
                        {bothTabsVisible() && (
                            <div className="menu-topbar text-subheading">
                                <span> Select target that contains your assets</span>
                            </div>
                        )}
                        <div className={"menu-head"}>
                            {props.showFolders && (
                                <div
                                    className={`menu-title menu-folder ${isFolderSelected && bothTabsVisible()
                                        ? "border"
                                        : bothTabsVisible()
                                            ? "no-border"
                                            : ""
                                        }`}
                                    onClick={() => handleFolderVisible()}
                                >
                                    Folders
                                </div>
                            )}
                            {props.showMoodboards && (
                                <div
                                    className={`menu-title menu-folder ${isMoodboardSelected && bothTabsVisible()
                                        ? "border"
                                        : bothTabsVisible()
                                            ? "no-border"
                                            : ""
                                        }`}
                                    onClick={() => handleMoodboardVisible()}
                                >
                                    Moodboards
                                </div>
                            )}
                        </div>
                        {isFolderSelected && (
                            <div className={"menu-body"}>
                                <FolderList
                                    folders={folders || []} close={props.closePanel} />
                            </div>
                        )}
                        {isMoodboardSelected && (
                            <MoodBoardList close={props.closePanel} />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
};